document.addEventListener('DOMContentLoaded', () => {

  const sections = [
    'shopify-section-template--24015821766795__section_ixjtHf', // home-how to works
    'shopify-section-template--24015821766795__section_wGKHEk', // home-magic Journey
    'shopify-section-template--24015821766795__section_LMgMPi' // home-real homes
  ];

  sections.forEach(id => {
    const section = document.getElementById(id);
    if (!section) return;

    const blocks = section.querySelectorAll('.group-block');

    blocks.forEach(block => {
      block.style.opacity = '0';
      block.style.transform = 'translateY(56px)';
      block.style.transition =
        'opacity 1.6s cubic-bezier(0.16,1,0.3,1), transform 1.6s cubic-bezier(0.16,1,0.3,1)';
    });

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {

        setTimeout(() => {
          blocks.forEach((block, index) => {
            setTimeout(() => {
              block.style.opacity = '1';
              block.style.transform = 'translateY(0)';
            }, index * 180);
          });
        }, 180);

        observer.disconnect();
      }
    }, {
      threshold: 0.18,
      rootMargin: '0px 0px -5% 0px'
    });

    observer.observe(section);
  });

});

/* ========================================================================
   WonderCrafter - How It Works Mobile Pagination
   ======================================================================== */

(function () {
  const section = document.getElementById(
    'shopify-section-template--24015821766795__section_ixjtHf'
  );
  if (!section) return;

  const track = section.querySelector('.layout-panel-flex--row');
  if (!track) return;

  const cards = track.children;
  if (!cards.length) return;

  // Create pagination automatically
  const pagination = document.createElement('div');
  pagination.className = 'wc-how-pagination';

  Array.from(cards).forEach((_, i) => {
    const dot = document.createElement('span');
    dot.className = 'wc-how-dot' + (i === 0 ? ' is-active' : '');
    pagination.appendChild(dot);
  });

  // Insert pagination after carousel
  track.insertAdjacentElement('afterend', pagination);

  const dots = pagination.querySelectorAll('.wc-how-dot');

  function updateDots() {
    const card = cards[0];
    const gap = 12;
    const cardWidth = card.getBoundingClientRect().width + gap;
    const index = Math.round(track.scrollLeft / cardWidth);

    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
  }

  track.addEventListener('scroll', () => {
    window.requestAnimationFrame(updateDots);
  });

  updateDots();
})();

/* ========================================================================
   WonderCrafter - Transformation Section Entrance Animation
   ======================================================================== */

(function () {
  const section = document.getElementById(
    'shopify-section-template--24015821766795__transformation_slider_EyViFA'
  );
  if (!section) return;

  section.style.opacity = '0';
  section.style.transform = 'translateY(24px)';
  section.style.transition =
    'opacity 1.2s cubic-bezier(0.16,1,0.3,1), transform 1.2s cubic-bezier(0.16,1,0.3,1)';

  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      section.style.opacity = '1';
      section.style.transform = 'translateY(0)';
      observer.disconnect();
    }
  }, {
    threshold: 0.18,
    rootMargin: '0px 0px -5% 0px'
  });

  observer.observe(section);
})();

/* ========================================================================
   WonderCrafter - Real Homes Mobile Pagination
   ======================================================================== */

(function () {
  const section = document.getElementById(
    'shopify-section-template--24015821766795__section_LMgMPi'
  );
  if (!section) return;

  const track = section.querySelector('.layout-panel-flex--row');
  if (!track) return;

  const cards = track.children;
  if (!cards.length) return;

  // Create pagination automatically
  const pagination = document.createElement('div');
  pagination.className = 'wc-home-pagination';

  Array.from(cards).forEach((_, i) => {
    const dot = document.createElement('span');
    dot.className = 'wc-home-dot' + (i === 0 ? ' is-active' : '');
    pagination.appendChild(dot);
  });

  // Insert pagination after carousel
  track.insertAdjacentElement('afterend', pagination);

  const dots = pagination.querySelectorAll('.wc-home-dot');

  function updateDots() {
    const card = cards[0];
    const gap = 12;
    const cardWidth = card.getBoundingClientRect().width + gap;
    const index = Math.round(track.scrollLeft / cardWidth);

    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
  }

  track.addEventListener('scroll', () => {
    window.requestAnimationFrame(updateDots);
  });

  updateDots();
})();

/* ========================================================================
   WonderCrafter - Magic Journey Mobile Pagination
   ======================================================================== */

(function () {
  const section = document.getElementById(
    'shopify-section-template--24015821766795__section_wGKHEk'
  );
  if (!section) return;

  const track = section.querySelector('.layout-panel-flex--row');
  if (!track) return;

  const cards = track.children;
  if (!cards.length) return;

  // Create pagination automatically
  const pagination = document.createElement('div');
  pagination.className = 'wc-magic-pagination';

  Array.from(cards).forEach((_, i) => {
    const dot = document.createElement('span');
    dot.className = 'wc-magic-dot' + (i === 0 ? ' is-active' : '');
    pagination.appendChild(dot);
  });

  // Insert pagination after carousel
  track.insertAdjacentElement('afterend', pagination);

  const dots = pagination.querySelectorAll('.wc-magic-dot');

  function updateDots() {
    const card = cards[0];
    const gap = 12;
    const cardWidth = card.getBoundingClientRect().width + gap;
    const index = Math.round(track.scrollLeft / cardWidth);

    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
  }

  track.addEventListener('scroll', () => {
    window.requestAnimationFrame(updateDots);
  });

  updateDots();
})();
